<template>
  <v-dialog v-model="showModal" max-width="500px" persistent>
    <v-card>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>{{title}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-form :class="visibility_class" @submit="handleSubmit">
          <v-container  grid-list-xl>
            <v-row row wrap>
              <v-col cols="12">
                <v-text-field label="Kod resortowy*" v-validate="'required'" name="kod_resortowy" id="kod_resortowy" :error-messages="errors.collect('kod_resortowy')" data-vv-as="Kod resortowy" v-model="kod_resortowy"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Nazwa*" v-validate="'required'" name="nazwa" id="nazwa"  :error-messages="errors.collect('nazwa')" data-vv-as="Nazwa"  v-model="nazwa"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-checkbox label="Czy aktywna?" v-model="is_active"></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm" color="error">Zamknij</v-btn>
        <v-btn color="success"   @click="handleSubmit">Zapisz</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import swal from "sweetalert";
import {settingsService} from "@/services";
export default {
  name: "AddEditJednostkaOrganizacyjna",
  data() {
    return {
      title: "Dodawanie nowej koórki organizacyjnej",
      loading: false,
      id: 0,
      nazwa: null,
      kod_resortowy: null,
      is_active: false,
      visibility_class: 'row',

    };
  },
  props: ["edited_object","visible"],
  methods: {
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    closeForm() {
      this.$emit("close");
    },
    handleSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.saveOU();
        }
      });
    },
    saveOU() {
      this.hide()
      if(this.id > 0)
      {
        settingsService.UpdateOrganizationalUnit({
          id: this.id,
          nazwa: this.nazwa,
          kod_resortowy: this.kod_resortowy,
          is_active: this.is_active
        }).then(() => {
            this.$emit('edited', {
              id: this.id,
              nazwa: this.nazwa,
              kod_resortowy: this.kod_resortowy,
              is_active: this.is_active
            })
        }).catch(() => {
          this.showError(false, 'Błąd aktualizacji komórki organizacyjnej')
        })
      }
      else
      {
        settingsService.AddOrganizationalUnit({
          nazwa: this.nazwa,
          kod_resortowy: this.kod_resortowy,
          is_active: this.is_active
        }).then((result) => {
          this.$emit('edited',result.data.result)
        }).catch(() => {
          this.showError(false, 'Błąd aktualizacji komórki organizacyjnej')
        })
      }
    },
    hide() {
      this.visibility_class = 'row scale-transition scale-out'
      this.loading = true
    },
    show() {
      this.visibility_class = 'row'
      this.loading = false
    },
  },
  computed: {
    showModal: {
      get: function() {
        return this.visible
      },
      set: function(value) {
        if(!value){
          this.$emit('close')
        }

      }
    }
  },
  watch: {
    edited_object: {
      immediate: true,
      handler(newval) {
        if(newval.id == 0)
        {
          this.title = 'Dodawanie nowej komórki organizacyjnej'
        }
        else
        {
          this.title = 'Edycja komórki organizacyjnej'
        }
        this.id = newval.id
        this.nazwa = newval.nazwa
        this.kod_resortowy = newval.kod_resortowy
        this.is_active = newval.is_active
      }
    },
  },
};
</script>

<style>

</style>
